import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import api from "../admin/api/api";
import { image_base_url } from "../admin/api/api";
import "./TopSelling.scss";

const TopSelling = () => {
  //const BASE_URL = "http://localhost:5170";
  
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    loadTopSellingProducts();
  }, []);

  const loadTopSellingProducts = async () => {
      try {
        const res = await api.get("/public/products/topselling");
        setProducts(res.data);
      } catch (error) {
        console.error("Error fetching new arrival products:", error);
      }
    };

  return (
    <div className=" box-shadow-normal">
      <h4 className="mb-3 pt-3 fw-bold">Top Selling Products</h4>

      <div className="top-selling-slider">
        {products.map((item) => (
          <Card
            key={item.productId}
            className="top-selling-card"
            onClick={() => navigate(`/product/${item.productId}`)}
          >
            <Card.Img
              variant="top"
              src={
                item.image
                  ? image_base_url + item.image
                  : "/images/no-image.png"
              }
              alt={item.productName}
              className="top-selling-img"
            />
            <Card.Body>
              <Card.Title style={{fontSize : "13px" , fontWeight :"bold"}}>{item.productName}</Card.Title>
              <div className="fw-bold">₹ {item.price}</div>
            </Card.Body>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default TopSelling;